import React, { Component } from 'react';
import { Link } from 'react-router';

import SpotifyPlayerLarge from '../../Media/SpotifyPlayerLarge';
import SpotifyFollowButton from '../../Media/SpotifyFollowButton';

export default class About extends Component {

  render() {
    return (
      <div className="About">
          <p>
          Moose Almighty is an indie rock jam band from Seattle, WA. Their modern approach to a retro sound blends seventies hard rock with swampy funk, blues, synth freakouts and dynamic improvisation, reminiscent of a hazy, acid tinged Saturday night in a southern dive bar.
          </p>
          <p>
          Moose Almighty’s third studio album 'Spare Parts’ was named the independent album of the year by Mic1Park Music Media who said “All self-produced, self-engineered - and all things between - this album is 10 out of 10 across the board. If you’re not careful, you can easily have this playing in the background and not even remember if you put on Moose Almighty or Grateful Dead.” Robert Fadley of JamBandPurist praised ‘Spare Parts’ as “A brand new ripping album... Ambitious and highly eclectic, these new tracks show the growth and knowledge that Moose Almighty has acquired from their last studio endeavor, while also incorporating what they have learned playing live shows. Moose Almighty has stepped up into another level...”’ 
          </p>
          <p>
          The bands first official live release, ‘We Play Shows’ was released in October 2021, and showcases Moose Almighty as a unique and formidable live band. It features performances from four shows in Seattle, Portland and Eugene in Summer 2021. The album is highlighted by a fiery, 26 minute ‘Rocky Racoon > The Wave’, extended cuts of ‘Polygonal Todd’ and ‘Tito’s Theme’ featuring original guitarist Chris Stein, and a deliciously outrageous covers of OMC’s 'How Bizarre’.
          </p>
          <p>
          Their music has been featured on The Sound Podcast with Ira Haberman, JEMP Radio, This Week In Seattle Rock and Dan’s Tunes Talking Tracks among others. Moose Almighty has played extensively around the Pacific Northwest, including venues such as Seattle’s Nectar Lounge and historic Central Saloon, Tacoma’s Spanish Ballroom and the Trail Mix Festival in Snoqualmie Pass. 
          </p>
          <p>
          Moose Almighty features Dan Underkofler (Keyboards, Synthesizers, Guitar, Vocals), Chris Young (Guitar, Vocals), Aaron Mitchell (Bass, Vocals), and Kevin Shoop (Drums, Vocals, Audio Engineering).
          </p>
      </div>    
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/About/About.js